module.exports = __webpack_public_path__ + "static/media/CostOpportunity_Diagram_Mobile_SV.4a2ee963.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/CostOpportunity_Diagram_Mobile_SV.png
// module id = 571
// module chunks = 0